/* eslint-disable @nx/enforce-module-boundaries */
import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@mybridge/ui';
import { forwardRef, useContext, useState } from 'react';
import { useForm } from 'react-hook-form';
import { DiskContext } from '../context';
import { DiskDirectoryTree } from '../directory-tree';
import { getFullFileName } from 'v4/lib/commons';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { useDirection } from '@mybridge/ui/custom-hooks/useDirection';
export const DiskMoveModal = forwardRef(({ ...props }, ref) => {
  const [selected, setSelected] = useState();
  const { moveFileFolder, selectedFile, moveDisc, moveFileFolderLoading } =
    useContext(DiskContext);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const onSubmit = () => {
    moveFileFolder({ file: selectedFile, parent: selected?.id });
  };
  const { t } = useTranslator();
  const direction = useDirection();
  

  return (
    <>
      <Modal size="2xl" {...moveDisc}>
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton {...(direction === 'rtl') ? {left: '0.75rem', right: 'auto'} : {left: 'auto', right: '0.75rem'}} />
          <ModalHeader>
            <Text truncate maxW="64">
              {t('myDisk.move') || "Move"} &quot;{getFullFileName(selectedFile)}&quot; {t('otherModules.here_to') || "here to"}...
            </Text>
          </ModalHeader>
          <ModalBody maxH="70vh" overflowY="auto">
            <DiskDirectoryTree setSelectedItem={setSelected} />
          </ModalBody>
          <ModalFooter>
            <Button
              borderRadius="30px"
              isLoading={moveFileFolderLoading}
              onClick={onSubmit}
              variant="primary"
            >
              {t('myDisk.move') || "Move"}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
});
